export default "<db:deckheader>\n\t<db:a data-id='anchor'></db:a>\n</db:deckheader>";